// extracted by mini-css-extract-plugin
module.exports = {"dialogHeader":"DialogHeader__dialogHeader___1lT72","mobile":"DialogHeader__mobile___1WzzL"};